import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'antd';

const FilterButton = ({ active, onToggleSider, type }) => (
  <div className="bhp-filter-button">
    <Button type={active ? 'primary' : 'default'} size="small" shape="circle" onClick={onToggleSider}>
      <Icon
        className="trigger"
        type={type}
      />
    </Button>
  </div>
);

FilterButton.propTypes = {
  active: PropTypes.bool,
  onToggleSider: PropTypes.func,
  type: PropTypes.string
};

FilterButton.defaultProps = {
  active: false,
  onToggleSider() {
  },
  type: 'filter'
};

export default FilterButton;
